const enum Endpoints {
    Approve = "Approve",
    Attendee = "Attendee",
    AttendeeTrainingHistories = "AttendeeTrainingHistories",
    Catalog = "Catalog",
    CatalogType = "CatalogType",
    Catalogs = "Catalogs",
    Category = "Category",
    Certificate = "Certificate",
    CertificateHistories = "CertificateHistories",
    CertificateType = "CertificateType",
    Certificates = "Certificates",
    Companies = "Companies",
    Company = "Company",
    CompanyHistories = "CompanyHistories",
    CountiesByProvince = "CountiesByProvince",
    Country = "Country",
    Counts = "Counts",
    County = "County",
    Dashboard = "Dashboard",
    Download = "Download",
    EffectEvalAnswer = "EffectEvalAnswer",
    EffectEvalQuestion = 'EffectEvalQuestion',
    EmployeeCalendar = "EmployeeCalendar",
    EmployeeTrainingRequest = "EmployeeTrainingRequest",
    EmployeeTrainingRequests = "EmployeeTrainingRequests",
    EvalAnswer = "EvalAnswer",
    EvalQuestionCategory = "EvalQuestionCategory",
    Exam = "Exam",
    ExamHistories = "ExamHistories",
    Exams = "Exams",
    Export = "Export",
    ExportExcel = "ExportExcel",
    ExtTrainingRequest = "ExtTrainingRequest",
    ExtTrainingRequestAttendee = "ExtTrainingRequestAttendee",
    ExtTrainingRequestAttendees = "ExtTrainingRequestAttendees",
    Facility = "Facility",
    GetCatalogList = "GetCatalogList",
    GetExpertList = "GetExpertList",
    GetTeamExpertList = "GetTeamExpertList",
    GetListByTrainingId = "GetListByTrainingId",
    GetStatusList = "GetStatusList",
    IntTrainingRequest = "IntTrainingRequest",
    IntTrainingRequestAttendee = "IntTrainingRequestAttendee",
    IntTrainingRequestAttendees = "IntTrainingRequestAttendees",
    Location = "Location",
    LoginUsers = "LoginUsers",
    Logs = "Logs",
    Print = "Print",
    Program = "Program",
    ProgramHistories = "ProgramHistories",
    Programs = "Programs",
    ProposalSelection = "ProposalSelection",
    Province = "Province",
    Report = "Report",
    RequestManagement = "RequestManagement",
    RoleGroup = "RoleGroup",
    Scholarship = "Scholarship",
    ScholarshipHistories = "ScholarshipHistories",
    Scholarships = "Scholarships",
    SignOut = "SignOut",
    Simple = "Simple",
    SsoAuthorization = "SsoAuthorization",
    TeamTrainings = "TeamTrainings",
    TopManagerHierarchy = "TopManagerHierarchy",
    Trainer = "Trainer",
    TrainerHistories = "TrainerHistories",
    Trainers = "Trainers",
    Training = "Training",
    TrainingEffectEval = "TrainingEffectEval",
    TrainingEval = "TrainingEval",
    TrainingHistories = "TrainingHistories",
    TrainingPlan = "TrainingPlan",
    TrainingSubPlan = "TrainingSubPlan",
    TrainingPlanAttendee = "TrainingPlanAttendee",
    TrainingPlanAttendees = "TrainingPlanAttendees",
    TrainingProposal = "TrainingProposal",
    TrainingRequest = "TrainingRequest",
    TrainingRequests = "TrainingRequests",
    TrainingRoom = "TrainingRoom",
    TrainingRoomFacility = "TrainingRoomFacility",
    TrainingRoomHistories = "TrainingRoomHistories",
    TrainingRooms = "TrainingRooms",
    TrainingTrainer = "TrainingTrainer",
    TrainingTrainers = "TrainingTrainers",
    Trainings = "Trainings",
    User = "User",
    UserDatum = "UserDatum",
    UserDatumHistories = "UserDatumHistories",
    UserDatums = "UserDatums",
    UserRoleGroup = "UserRoleGroup",
    UserRoleGroupHistories = "UserRoleGroupHistories",
    UserRoleGroups = "UserRoleGroups",
    WithCatalog = "WithCatalog",
}

export default Endpoints;